// The Excel report's work sheets in the report's look (cellStyle.js), the same as sheet 1: headers by category, task
// cells by status, the CO groups, the script's red rule framed red, the header row and A-C frozen. Exactly Week 43's
// columns; the sheet's own next task framed black (all but Soil_Sample and Harvest).
// Under the data, as in the template, the planners' legend row: their person colours without text.
import { BASE_HEADERS } from './baseSheet';
import { PERSON_COLOURS } from './colours';
import {
  addHeaderRow, categoryStarts, coGroups, fallbackFill, isTaskColumn, scriptRedRule, setDataCell, setUpSheet, styleCell,
} from './cellStyle';
import { WORK_SHEETS, sheetNextTask, workSheetHeaders, workSheetRow, workSheetSelection } from './workSheets';

export const BORDERSPRAY_NOTE = 'Please put a date or write "Not needed"';

/**
 * The legend row under a work sheet's data, one empty row below it, as in the Week 43 template (row 25 / 55): the
 * planners' 9 person colours from column C, without text, so they can write their names by them; on Borderspray the
 * template's note in its last cell (S).
 */
export function addLegendRow(sheet, sheetName, lastDataRow) {
  const row = sheet.getRow(lastDataRow + 2);
  let c = 3;
  for (const { cells, colour } of PERSON_COLOURS) {
    for (let i = 0; i < cells; i++, c++) row.getCell(c).fill = { type: 'pattern', pattern: 'solid', fgColor: colour };
  }
  if (sheetName === 'Borderspray') row.getCell(c - 1).value = BORDERSPRAY_NOTE;
  return row.number;
}

/** Adds the 7 work sheets for sheet 1's rows (baseRow, in sheet 1's order) on `exportDate` to an ExcelJS workbook. */
export function addWorkSheets(workbook, baseRows, exportDate = new Date()) {
  const selection = workSheetSelection(baseRows);
  for (const def of WORK_SHEETS) {
    const sheet = workbook.addWorksheet(def.name);
    const headers = workSheetHeaders(def, BASE_HEADERS);
    addHeaderRow(sheet, headers);
    setUpSheet(sheet, headers.indexOf('Trial') + 1); // A-C: CO, CustomerNo, Trial

    const starts = categoryStarts(headers);
    const groups = coGroups(selection[def.name].map(({ values }) => values[0]));
    selection[def.name].forEach((trial, r) => {
      const next = sheetNextTask(def, trial.byColumn, exportDate);
      const cells = workSheetRow(def, trial.values, BASE_HEADERS);
      const statuses = workSheetRow(def, trial.statuses, BASE_HEADERS);
      const framed = next?.header ? headers.indexOf(next.header) : -1;
      const warnings = scriptRedRule(headers, cells, statuses);
      const { shade, coStart } = groups[r];
      const row = sheet.getRow(r + 2);
      cells.forEach((value, c) => {
        const cell = row.getCell(c + 1);
        setDataCell(cell, value, { categoryStart: starts[c], coStart, task: isTaskColumn(headers[c]) });
        styleCell(cell, {
          status: statuses[c]?.status, next: c === framed, warning: warnings.includes(c), fallbackFill: fallbackFill(headers[c], shade),
        });
      });
    });
    sheet.autoFilter = { from: { row: 1, column: 1 }, to: { row: selection[def.name].length + 1, column: headers.length } };
    addLegendRow(sheet, def.name, selection[def.name].length + 1);
  }
  return selection;
}
